import { Grid, LinearProgress as LinearProgressMui } from '@mui/material';
import React from 'react';
import './styles.scss';

export const LinearProgress = () => {
  return (
    <div>
      <Grid item sm={12}>
        <LinearProgressMui className="gtc-rc-linear-progress" color="success"/>
      </Grid>
    </div>
  );
};